/**
 * Module « configuration » — CFG-01 à CFG-07.
 *
 * Un seul écran (`ConfigurationPage`) organisé en onglets : identité du
 * théâtre, éditeur de plan de salle, catégories de public, types de
 * déduction, comptes du personnel. Monté sous `/admin/configuration`,
 * réservé au rôle `admin` (ARCHITECTURE §8, `router.tsx`).
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

const ConfigurationPage = lazy(() =>
  import('./ConfigurationPage').then((m) => ({ default: m.ConfigurationPage })),
)

export const routesConfiguration: RouteObject[] = [
  {
    index: true,
    element: <ConfigurationPage />,
  },
]
